import { render } from "./StockIndex.vue?vue&type=template&id=6f90bc89&scoped=true"
import script from "./StockIndex.vue?vue&type=script&lang=js"
export * from "./StockIndex.vue?vue&type=script&lang=js"

import "./StockIndex.vue?vue&type=style&index=0&id=6f90bc89&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f90bc89"]])

export default __exports__